import { formatDistanceToNowStrict } from "date-fns";
import React from "react";
import useInvitations from "../hooks/useInvitations";
import Box from "./Box";

export default function () {
  const { invitations } = useInvitations();

  const numClaimed = invitations.filter((i) => i.square !== undefined).length;

  return (
    <Box
      title="poster status"
      backgroundColor="lightPink"
      borderColor="papayawhip"
    >
      invitations created:&nbsp;{invitations.length} of 72+
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;squares claimed:&nbsp;{numClaimed} of 72 (
      {((numClaimed / 72) * 100).toFixed(2)}%)
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;time remaining:&nbsp;
      {formatDistanceToNowStrict(new Date(2021, 0, 1))}
      <br />
    </Box>
  );
}
